import PropTypes from 'prop-types'
import * as React from 'react'
import SidebarInfo from './SidebarInfo/SidebarInfo'
import SidebarPendingOrder from './SidebarPendingOrder/SidebarPendingOrder'


function SidebarInitActions({ isLeftActiveTab, isInfo }) {
	return (
		isInfo ?
			<SidebarInfo isBasicTab={isLeftActiveTab}/> :
			<SidebarPendingOrder isOpenTradeTab={isLeftActiveTab} />
	)
}

SidebarInitActions.propTypes = {
	isInfo: PropTypes.bool,
	isLeftActiveTab: PropTypes.bool
}
export default SidebarInitActions
